import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { getUserSubscrptions, updateUser } from '../queries/login.query';
@Injectable()
export class DetailsService {

  constructor(private http: HttpClient,private apollo: Apollo) { }

  // async updateDetails(details,id): Promise<any> {

  //   let headers = {"x-hasura-admin-secret":`${environment.x_hasura_admin_secret}`};
  //   //headers.append('Content-Type', 'application/json');
  //   //headers.append('x-hasura-admin-secret', `${environment.x_hasura_admin_secret}`);
  //   console.log(details)
  //   const cm = {payload:details}
  //   const a = {id:id,object:cm}
  //   console.log(a)
  //   try {
  //     const response = await this.http.post(`${environment.serverBasePath}/api/rest/update-lead`, a, { headers : headers }).toPromise();
  //     return response;
  //   } catch (error) {
  //     console.log(error)
  //     throw error;
  //   }
  // }


 async updateDetails(userData,id): Promise<any>{
  console.log(userData)
  const updateObj = userData
    try{
      
   
    return await this.apollo.mutate({
      mutation: updateUser,
      variables: {id,updateObj}
    }).pipe(pluck('data', 'update_clients_by_pk')).toPromise();

    }catch (error) {
           console.log(error)
           throw error;
         }
    
  }




  getuserSub(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getUserSubscrptions,
      variables: {id}
    }).pipe(pluck('data', 'user_subscriptions'));
  }


}
